import { Drawer } from "antd";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";
import Fields from "../Fields";
import { toDiscountCodeFormValues } from "../form";
import validation from "../validation";

const Detail = ({ onSubmit, open, onClose }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DISCOUNT_CODE);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });

  return (
    <Drawer
      open={!isEmpty(open)}
      className="drawer__area"
      title={DETAIL.TITLE}
      width={500}
      onClose={onClose}
      placement="right"
    >
      <Formik
        enableReinitialize={true}
        initialValues={toDiscountCodeFormValues(open)}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values);
          resetForm();
        }}
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
        )}
      >
        {({ handleSubmit, setFieldValue, values, ...formProps }) => (
          <>
            <Fields
              formProps={formProps}
              values={values}
              setFieldValue={setFieldValue}
              FORM={FORM}
            />
            <div className="mt-16">
              <Button type="primary" size="full--width" onClick={handleSubmit}>
                {FORM.SUBMIT}
              </Button>
            </div>
          </>
        )}
      </Formik>
    </Drawer>
  );
};

export default Detail;
